export default function extractVideoIdFromYoutubeUrl(url) {
    /*eslint-disable */
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[7].length === 11) ? match[7] : false;
    /*eslint-enable */
  }


// WEBPACK FOOTER //
// ./src/app/util/extractVideoIdFromYoutube.js